import React from 'react';
import LegalPage from '../components/LegalPage';

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    description="How AVbot, the Web3 Discord bot, collects, uses, stores, and protects your data."
    file="privacy.md"
  />
);

export default Privacy;
